import { Component, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
    templateUrl: 'yes-no-dialog.component.html',
    styleUrls: ['yes-no-dialog.component.scss'],
    imports: [MatToolbar, MatIcon, MatButton]
})
export class YesNoDialogComponent {
  dialogRef = inject<MatDialogRef<YesNoDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);


  onYes() {
    this.dialogRef.close(true);
  }

  onNo() {
    this.dialogRef.close(false);
  }

}
